export const loadStyle = (src: string, async = true) => {
  const el = document.createElement("link");

  el.type = "text/css";
  // @ts-expect-error
  el.async = async;

  el.href = src;
  el.rel = "stylesheet";
  el.media = "all";

  const x = document.getElementsByTagName("head")[0];
  x.appendChild(el);
};
